import { attributes } from "./constants";
export default function deserializeDataAdapters({
  query,
  total,
  page,
  per_page,
  count,
  data_adapters
}) {
  var _a;
  return {
    attributes,
    list: (_a = data_adapters.map((adapter) => ({ ...adapter, id: adapter.id }))) != null ? _a : [],
    pagination: { total, page, per_page, count, query }
  };
}
